import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 text-center shadow-soft border border-brand-beige relative overflow-hidden" data-id="element-76">
          <div className="absolute -top-10 -right-10 text-brand-beige opacity-20" data-id="element-77">
            <ShieldCheck className="w-48 h-48" data-id="element-78" />
          </div>

          <div className="relative z-10" data-id="element-79">
            <div className="bg-brand-gold/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-80">
              <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-81" />
            </div>
            <h2 className="text-3xl font-bold text-brand-navy mb-6" data-id="element-82">
              Tu compra está protegida.
            </h2>
            <div className="space-y-4 text-lg text-gray-700" data-id="element-83">
              <p data-id="element-84">
                Si después de recibir el pack sientes que no era lo que
                esperabas, escríbenos dentro de los primeros 7 días y te
                devolvemos tu dinero sin preguntas.
              </p>
              <p className="font-medium" data-id="element-85">
                No queremos que te quedes con algo que no te sirva. Pero estamos
                seguros de que cuando lo veas, querrás empezar a usarlo de
                inmediato.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}